import { ENDPOINTS } from 'src/constants/endpoints'

import type { IFundUpdateCategoriesResponseDTO } from 'src/app/home/pages/fund-updates/domain/contracts/fund-updates'
import { http } from 'src/interfaces/http'

export const getFundUpdateCategories =
  async (): Promise<IFundUpdateCategoriesResponseDTO> => {
    const { data } = await http.get<IFundUpdateCategoriesResponseDTO>(
      ENDPOINTS.hanwha.fundUpdateCategories,
    )
    return data
  }
